import { Platforms } from 'src/redux/slices/platform';
import { Badge } from '../ui/badge';
import { useSelector } from 'src/redux/store';
import {
  selectHasPlatformWorkspaces,
  selectPlatformIsTrialing,
} from 'src/redux/selectors/workspaces';
import { useTranslation } from 'react-i18next';

/**
 * Takes a product type and returns a badge
 * if given product workspace doesn't exist = Not created
 * if the given product is trialing. = Trialing
 * if has Stripe subscription for given product = null
 *
 * @returns
 */

export default function ProductNavBadge({ productType }: { productType: Platforms }) {
  const { t } = useTranslation();
  const trial = useSelector(selectPlatformIsTrialing(productType));
  const hasWorkspace = useSelector(selectHasPlatformWorkspaces(productType));

  if (trial?.isTrialing) {
    return (
      <Badge className="text-[10px] bg-blue-100 text-blue-800 border-blue-100 hover:bg-blue-100 hover:text-blue-800">
        {t('nav.product_nav_badge.trialing')}
      </Badge>
    );
  }
  if (!hasWorkspace) {
    return (
      <Badge className="text-[10px] bg-gray-100 text-gray-800 border-gray-100 hover:bg-gray-100 hover:text-gray-800">
        {t('nav.product_nav_badge.not_setup')}
      </Badge>
    );
  }
  return null;
}
